// extracted by mini-css-extract-plugin
export default {"preferences":"_3vqYc","oneClickActive":"hBfsg"};